import { connect } from 'react-redux';
import Login from './login';
import {
  updateSession,
  syncUserData,
  signup,
} from '../../store/actions/user.actions';

const mapDispatchToProps = {
  updateSession,
  syncUserData,
  signup,
};

export default connect(null, mapDispatchToProps)(Login);
